import React, { Component, Fragment } from 'react';
import { Button, Modal, Select, Spin, Divider, Radio, Row, Alert } from 'antd';
import { Menu, Customer } from '../../../../services/api';
import { DayOfWeek, MealType } from '../../../../components/Label';

export default class AddRecipe extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: {
                menus: false,
                menu: false,
                save: false
            },
            modalVisible: false,
            menus: [],
            menu: null,
            newMenu: '',
            menuId: null,
            customer: {},
            dayOfWeek: 'MONDAY',
            mealType: 'BREAKFAST'
        }

        this.menuApi = new Menu(props);
        this.customerApi = new Customer(props);
    }

    componentWillUnmount() {
        this.isCancelled = true;
    }

    showAddModal = () => {
        this.setState({ modalVisible: true });
        this.fetchCustomer();
    }

    fetchCustomer = () => {
        const { loading } = this.state;
        loading.menus = true;
        this.setState({ loading });

        this.customerApi.me()
            .then(res => {
                this.setState({ customer: res.data.data });
                this.fetchMenus();
            })
            .catch(_ => {
                this.customerApi.retry({ cb: this.fetchCustomer });
            });
    }

    fetchMenus = () => {
        const { customer, loading } = this.state;
        this.customerApi.raw().get(customer._links.menus.href)
            .then(res => {
                const menus = res.data.data.filter(m => m.custom === true);
                loading.menus = false;
                this.setState({ menus: menus, loading });
            })
            .catch(_ => {
                this.customerApi.retry({ cb: this.fetchMenus });
            });
    }

    handleCancel = () => {
        this.setState({ modalVisible: false });
    }

    saveMeal = () => {
        const { menu, dayOfWeek, mealType, loading } = this.state;
        const day = menu && menu._embedded['varma:days'].data.find(d => d.day_of_week === dayOfWeek);
        if (day) {
            this.patchDay(day);
            return;
        }

        const { recipe } = this.props;

        const data = {
            day_of_week: dayOfWeek,
            meals: [{
                type: mealType, 
                recipe: {
                    id: recipe.id,
                    title: recipe.title,
                    image: recipe.images[0].url,
                    tags: recipe.tags
                }
            }]
        };

        loading.save = true;
        this.setState({ loading });
        
        this.menuApi.addDay(menu.id, data)
            .then(() => {
                loading.save = false;
                this.setState({ loading, modalVisible: false, dayOfWeek: 'MONDAY', mealType: 'BREAKFAST' });
            })
            .catch(_ => {
                this.menuApi.retry({ cb: this.createMeal });
            });
    }
    
    patchDay = (day) => {
        const { mealType, loading } = this.state;

        const { recipe } = this.props;
        const data = {
            meals: [{
                type: mealType, 
                recipe: {
                    id: recipe.id,
                    title: recipe.title,
                    image: recipe.images[0].url,
                    tags: recipe.tags
                }
            }]
        };

        loading.save = true;
        this.setState({ loading });
        
        this.menuApi.raw().patch(day._links.patch.href, data)
            .then(() => {
                loading.save = false;
                this.setState({ loading, modalVisible: false, dayOfWeek: 'MONDAY', mealType: 'BREAKFAST' });
            })
            .catch(_ => {
                this.menuApi.retry({ params: [day], cb: this.patchDay });
            });
    }

    fetchOriginMenu = (id) => {
        const { menus, loading } = this.state;
        loading.menu = true;
        this.setState({ loading });
        
        const index = menus.findIndex(m => m.origin.id === id);
        const menu = menus[index];
        this.menuApi.raw().get(menu._links.origin.href)
            .then(res => {
                loading.menu = false;
                this.setState({ menu: res.data.data, loading });
            })
            .catch(_ => {
                this.menuApi.retry({ params: [id], cb: this.fetchOriginMenu });
            });
    }

    onSelectMenu = (value) => {
        if (value !== undefined) {
            this.fetchOriginMenu(value);
        }
    }

    render() {
        const { loading, modalVisible, menus, menu } = this.state;

        return (
            <Fragment>
                <Button style={this.props.style} type="primary" icon="heart" onClick={this.showAddModal}>
                    Spara i meny
                </Button>

                <Modal
                    title="Lägg till i meny"
                    visible={modalVisible}
                    okText="Lägg till"
                    cancelText="Avbryt"
                    onOk={this.saveMeal}
                    onCancel={this.handleCancel}
                    okButtonProps={{ loading: loading.save, disabled: menus.length === 0 || !menu }}
                >
                    <Row type="flex" justify="center">
                        <Divider style={{ marginTop: 0 }}>1. Välj meny</Divider>
                        {loading.menus && <div style={{ textAlign: 'center' }}><Spin /></div>}
                        {!loading.menus && menus.length === 0 && (
                            <Alert showIcon type="info" message="Personliga menyer sakans. Du kan skapa personliga menyer från menysidan." />
                        )}
                        {!loading.menus && menus.length > 0 && (
                            <Fragment>
                                <Select
                                    showSearch
                                    allowClear={true}
                                    style={{ width: '70%' }}
                                    placeholder="Välj meny"
                                    optionFilterProp="children"
                                    onChange={this.onSelectMenu}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {menus.map(m => <Select.Option key={m.id} value={m.origin.id}>{m.origin.title}</Select.Option>)}
                                </Select>
                            </Fragment>
                        )}

                        <Divider style={{ marginTop: '30px' }}>2. Välj dag</Divider>
                        <Radio.Group onChange={e => this.setState({ dayOfWeek: e.target.value })} defaultValue="MONDAY" buttonStyle="solid">
                            <Radio.Button value="MONDAY"><DayOfWeek type="MONDAY" format="short" /></Radio.Button>
                            <Radio.Button value="TUESDAY"><DayOfWeek type="TUESDAY" format="short" /></Radio.Button>
                            <Radio.Button value="WEDNESDAY"><DayOfWeek type="WEDNESDAY" format="short" /></Radio.Button>
                            <Radio.Button value="THURSDAY"><DayOfWeek type="THURSDAY" format="short" /></Radio.Button>
                            <Radio.Button value="FRIDAY"><DayOfWeek type="FRIDAY" format="short" /></Radio.Button>
                            <Radio.Button value="SATURDAY"><DayOfWeek type="SATURDAY" format="short" /></Radio.Button>
                            <Radio.Button value="SUNDAY"><DayOfWeek type="SUNDAY" format="short" /></Radio.Button>
                        </Radio.Group>

                        <Divider style={{ marginTop: '30px' }}>3. Välj måltid</Divider>
                        <Radio.Group onChange={e => this.setState({ mealType: e.target.value })} defaultValue="BREAKFAST" buttonStyle="solid">
                            <Radio.Button value="BREAKFAST"><MealType type="BREAKFAST" /></Radio.Button>
                            <Radio.Button value="LUNCH"><MealType type="LUNCH" /></Radio.Button>
                            <Radio.Button value="DINNER"><MealType type="DINNER" /></Radio.Button>
                        </Radio.Group>
                    </Row>

                </Modal>
            </Fragment>
        )
    };
}



// WEBPACK FOOTER //
// ./src/screens/dashboard/components/menu/AddRecipe.js